var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotNumber = function SvgHotspotNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.875 10.518H14.73l-.687 2.848h2.128v1.088h-2.384l-.785 3.216h-1.168l.8-3.216H9.948l-.784 3.216H7.995l.8-3.216H6.987v-1.088H9.05l.688-2.848H7.69V9.494h2.304l.768-3.184h1.168l-.784 3.184h2.688l.767-3.184h1.168l-.784 3.184h1.889zm-3.985 2.848.688-2.848h-2.687l-.688 2.848z"
  })));
};
export default SvgHotspotNumber;